import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Loader, textToHTML } from '@siteground/styleguide';
import { getHttpRequests } from '../../selectors/http-requests';
import { getChatSettings } from '../../selectors/chat';
import { useDelayedRender } from '../../hooks/useDelayedRender';

/**  @param {PartialLoaderTypes} props */
const PartialLoader = ({ children, resources }) => {
  const { specified, unspecified } = useSelector(getHttpRequests);
  const isWebsocketConnectivityActive = useSelector(({ chatSession }) => chatSession.isWebsocketConnectivityActive);
  const { minimized } = useSelector(getChatSettings);

  const hasSpecifiedRequest = specified.find((request) => Array.isArray(resources) && resources.includes(request));
  const isLoading = Boolean(hasSpecifiedRequest) || unspecified > 0 || !isWebsocketConnectivityActive;
  const shouldShowLoader = useDelayedRender(isLoading);
  const intl = useIntl();

  return (
    <React.Fragment>
      {shouldShowLoader && !minimized && (
        <Loader background="dark" spinnerPosition="absolute" position="absolute">
          {!isWebsocketConnectivityActive &&
            textToHTML(intl.formatMessage({ id: 'connection.lost.trying.to.reconnect' }))}
        </Loader>
      )}

      {children}
    </React.Fragment>
  );
};

export default PartialLoader;
